/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-17 22:25:57
 * @LastEditors: wangyunlin wangyunlin@morewis.com
 * @LastEditTime: 2022-11-02 10:31:55
 * @FilePath: \douyin\src\api\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import serverUrl from "./serveUrl";
const request = axios.create({
    timeout: 20000,
    'Content-Type': 'application/json',
})
request.interceptors.request.use(function(config) {
    return config;
}, function(error) {
    return Promise.reject(error);
});

request.interceptors.response.use(function(response) {
    return response.data;
}, function(error) {
    return Promise.reject(error);
});
export default request;